import React from 'react';

export const JsonLd = ({ data }) => {
  const schemas = Array.isArray(data) ? data : [data];

  return (
    <>
      {schemas.filter(Boolean).map((schema, index) => (
        <script
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          key={`jsonld-${schema['@type'] || index}`}
          type="application/ld+json"
        />
      ))}
    </>
  );
};
